var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.props.value?.jobs)?_c(_setup.InstanceTaskStatus,{attrs:{"instance":_setup.props.value}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }